var map = {
	"./Kael'thas_HotS_art.webp": 89447,
	"./anduin.webp": 38641,
	"./anubarak.webp": 27465,
	"./artanis.webp": 3212,
	"./auriel.webp": 50160,
	"./blaze.webp": 63578,
	"./brightwing.webp": 47293,
	"./cassia.webp": 43678,
	"./chromie.webp": 54547,
	"./deckard.webp": 24424,
	"./dehaka.webp": 99298,
	"./etc.webp": 95104,
	"./falstad.webp": 26435,
	"./garrosh.webp": 96744,
	"./gazlowe.webp": 83177,
	"./genji.webp": 61897,
	"./greymane.webp": 36466,
	"./guldan.webp": 99173,
	"./jaina.webp": 32339,
	"./johanna.webp": 35633,
	"./junkrat.webp": 45931,
	"./kaelthas.webp": 59767,
	"./li-ming.webp": 75465,
	"./lili.webp": 29630,
	"./lt-morales.webp": 25724,
	"./lucio.webp": 39182,
	"./lunara.webp": 6697,
	"./malthael.webp": 20994,
	"./muradin.webp": 91800,
	"./qhira.webp": 31703,
	"./raynor.webp": 34369,
	"./rehgar.webp": 90313,
	"./rexxar.webp": 5936,
	"./sgt-hammer.webp": 11553,
	"./sonya.webp": 65364,
	"./thrall.webp": 65319,
	"./tychus.webp": 1974,
	"./valla.webp": 47534,
	"./xul.webp": 8543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16813;